module.exports = __webpack_public_path__ + "img/yc.b638600c.png";